import React from 'react';
import './css/Menu.css';

class Menu extends React.Component {
    render() {

        const text = this.props.text;

        return (

        <div className={`Menu ${this.props.isVisible ? 'visible' : 'hidden'}`}>
            <h1>{text.Header}</h1>
            {text.Type === "menu" ? text.Items.map( ( item, i ) => <p key={item.name} className={this.props.disabled ? 'disabled' : ""}><button onClick={() => { this.props.setProcess(i); this.props.toggleMenu(); }}>{item.name}</button></p> ) : null}
            <h3>This app runs best on a PC or laptop, at a resolution of at least 1280x720.</h3>

        </div>

        );
    }
}

export default Menu;
